import React from "react";
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup
} from "react-leaflet";

import L from "leaflet";

import "leaflet/dist/leaflet.css";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl:
        "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const InteractiveMap = ({ lat, lng, destinationName }) => {

    if (!lat || !lng) {
        return <p>No Location Found</p>;
    }

    return (
        <MapContainer
            center={[lat, lng]}
            zoom={13}
            scrollWheelZoom={true}
            style={{
                height: "400px",
                width: "100%",
                borderRadius: "12px",
            }}
        >
            <TileLayer
                attribution='&copy; OpenStreetMap'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <Marker position={[lat, lng]}>
                <Popup>
                    {destinationName}
                </Popup>
            </Marker>

        </MapContainer>
    );
};

export default InteractiveMap;